/**
 * PATH: apps/hr/src/components/settings/DocumentTypeSettingsTab.tsx
 * PURPOSE: Document type settings tab content for the Settings modal (real-data only)
 *
 * WHY:
 * - Previously this tab used mock document types, which must not ship to production.
 * - Document/OCR configuration is not yet backed by an HR API in this hub.
 */

import { FileText } from 'lucide-react'
import { EmptyState } from '../ui/EmptyState'

export function DocumentTypeSettingsTab() {
  return (
    <EmptyState
      icon={FileText}
      title="Document types not connected"
      description="This settings tab has been cleaned up to remove dummy data. Once documents/OCR settings are backed by a real API, configuration will appear here."
    />
  )
}

export default DocumentTypeSettingsTab
